import { motion } from "framer-motion";
import { PaintRoller, Hammer, Grid3x3, LayoutPanelLeft, Plug, Sparkles, Frame, SprayCan, CloudRain, Leaf, Waves, Fence } from "lucide-react";

const SERVICES = [
  { id: "Painting & touch-ups", icon: PaintRoller, blurb: "Scuffs, patches, feature walls, whole rooms." },
  { id: "Wall & ceiling repair", icon: Hammer, blurb: "Holes, cracks, plaster, cornices." },
  { id: "Cracked & damaged tiles", icon: Grid3x3, blurb: "Bathroom, kitchen, splashbacks." },
  { id: "Floors, walls & benches", icon: LayoutPanelLeft, blurb: "Timber, laminate, stone, chips & scratches." },
  { id: "Broken appliances", icon: Plug, blurb: "Ovens, dishwashers, dryers, small fixes." },
  { id: "End-of-lease make-goods", icon: Sparkles, blurb: "Bond-back specials for renters." },
  { id: "Broken glass replacement", icon: Frame, blurb: "Windows, splashbacks, mirrors, shopfronts." },
  { id: "Pressure washing", icon: SprayCan, blurb: "Driveways, paths, decks, exteriors, roofs." },
  { id: "Roof leaks", icon: CloudRain, blurb: "Minor leak fixes, tile & flashing repairs." },
  { id: "Yard clean-ups & lawn mowing", icon: Leaf, blurb: "Overgrown lawns, tidy-ups, green waste removal." },
  { id: "Gutter cleaning & repairs", icon: Waves, blurb: "Clear blockages, refit brackets, patch leaks." },
  { id: "Fence & gate repairs", icon: Fence, blurb: "Palings, hinges, sagging gates, latches." },
];

export default function Services({ onPick }) {
  return (
    <section id="services" className="py-24 lg:py-32 bg-muted/40 border-b border-border">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="text-xs uppercase tracking-widest text-primary mb-3">What we fix</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-secondary leading-none">
              The small stuff.<br />
              Sorted <span className="text-primary">properly.</span>
            </h2>
          </div>
          <p className="text-muted-foreground max-w-md leading-relaxed">
            If it's minor, cosmetic, or a "make-good" — it's our sweet spot. Not sure? Send a photo anyway, we'll tell you straight up.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="services-grid">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.button
                key={s.id}
                type="button"
                onClick={() => onPick(s.id)}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                className="group relative bg-card text-left rounded-sm border border-border p-7 hover:border-primary transition-colors"
                data-testid={`service-${i}`}
              >
                <div className="w-11 h-11 rounded-sm bg-muted grid place-items-center text-secondary group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
                  <Icon size={20} />
                </div>
                <h3 className="font-display text-xl font-semibold mt-5 text-secondary">{s.id}</h3>
                <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{s.blurb}</p>
                <div className="mt-5 text-sm font-medium text-primary opacity-0 group-hover:opacity-100 transition-opacity">
                  Quote this →
                </div>
              </motion.button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
